// Small icon+text pill used in the profile hero's "professional info" row
// (location, company, watchlist count, achievements count). This file used
// to be a byte-for-byte copy of ConnectionTab.jsx's entire "Connections"
// section (header, Following/Followers tabs, search bar, connection cards)
// -- its default export ignored the icon/text props this component is
// actually called with, so every truthy chip condition in profile.jsx
// rendered a full duplicate Connections block inline in that small chip
// row instead of a pill, which is what actually caused the "duplication"
// and oversized gap around Connections that was reported.
const InfoChip = ({ icon: Icon, text, className = '' }) => {
  if (!text) return null;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full
        bg-gray-100 dark:bg-gray-800/60 border border-gray-200 dark:border-gray-700/60
        text-gray-600 dark:text-gray-300 ${className}`}
    >
      {Icon && <Icon className="w-3.5 h-3.5 flex-shrink-0 text-gray-500 dark:text-gray-400" />}
      <span className="truncate max-w-[12rem] sm:max-w-none">{text}</span>
    </span>
  );
};

export default InfoChip;
